module.exports = __webpack_public_path__ + "5b2e41c34b6ee3de262a199953a252cc.png";